const env = process.env.REACT_APP_ENVIRONMENT;

/**
 * Client-side logger (HORO-10474).
 *
 * This used to be a stub: `canLog()` required `env === 'local'` and the
 * `console.log` body was commented out, so every call site here — the websocket
 * layer, the analytics init, the payment buttons — logged precisely nothing, in
 * every environment. That is why a failing request could only be reported as "it
 * went back to the homepage".
 *
 * `log` stays quiet outside local: it is used for chatty websocket tracing and
 * would drown the console. `warn` and `error` are always emitted, because the
 * console is the only artifact a user or QA can actually hand back to us — a
 * screenshot of it is often the whole bug report.
 */
class LoggerService {
    constructor(env) {
        this.env = env;
    }

    canLog() {
        return this.env === 'local' || this.env === 'development' || this.env === 'dev';
    }

    log(message, ...rest) {
        if (this.canLog()) {
            // eslint-disable-next-line no-console
            console.log(message, ...rest);
        }
    }

    warn(message, ...rest) {
        // eslint-disable-next-line no-console
        console.warn(message, ...rest);
    }

    error(message, ...rest) {
        // eslint-disable-next-line no-console
        console.error(message, ...rest);
    }
}

export default new LoggerService(env);
